var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-text-generic module",class:[
    { 'content-text-generic--centered': _vm.item && _vm.item.IsCentered },
    { 'content-text-generic--quote-centered': _vm.item && _vm.item.IsQuoteCenter } ]},[(_vm.item)?_c('div',{class:{ 'content-text-generic--drop-letter': _vm.item.IsDropLetter },domProps:{"innerHTML":_vm._s(_vm.TextData)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }